import { render, staticRenderFns } from "./Roullet_.vue?vue&type=template&id=e6ccc128&scoped=true&"
import script from "./Roullet_.vue?vue&type=script&lang=js&"
export * from "./Roullet_.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ccc128",
  null
  
)

export default component.exports